import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'uikit-save-applied-filters-dialog',
  template: `
    <h2 matDialogTitle>{{ 'FRONTEND.UIKIT.VA_FILTER.CHOOSE_FILTER_NAME' | translate }}</h2>
    <mat-dialog-content>
      <EXP__glxy-wrap>
        <mat-form-field class="full-width" [appearance]="'outline'">
          <input matInput #nameInput placeholder="Name" name="savedfilterName" (keyup.enter)="close()" />
        </mat-form-field>
      </EXP__glxy-wrap>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="primary" (click)="close()">
        {{ 'FRONTEND.UIKIT.VA_FILTER.SAVE_YOUR_FILTER' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./save-applied-filters-dialog.component.scss'],
  standalone: false,
})
export class SaveAppliedFiltersDialogComponent {
  @ViewChild('nameInput', { static: true }) nameInput: ElementRef;
  constructor(public dialogRef: MatDialogRef<SaveAppliedFiltersDialogComponent>) {}

  close(): void {
    this.dialogRef.close(this.nameInput.nativeElement.value);
  }
}
